<script setup lang="ts">
import art from "~/assets/art";

const { slug } = useRoute().params;

const piece = art.find((piece) => piece.slug === slug);
if (!piece) {
  throw createError({
    statusCode: 404,
    message: "Artwork not found",
    fatal: true,
  });
}
</script>

<template>
  <div class="p-4">
    <div class="bg-white">
      <!-- Two-Column Layout -->
      <div class="grid grid-cols-1 gap-8 p-8 lg:grid-cols-2">
        <!-- Main Image Section -->
        <div class="flex justify-center">
          <a
            :href="piece.mainImage"
            aria-label="Open full size image"
            class="overflow-hidden p-8"
            :class="piece.frameColor"
          >
            <img :src="piece.mainImage" :alt="piece.alt" class="max-h-[500px] object-contain" />
          </a>
        </div>
        <!-- Content Section -->
        <div>
          <h1 class="mb-4 text-4xl font-bold text-gray-900">
            {{ piece.title }}
          </h1>

          <p class="text-lg text-gray-600">{{ piece.description }}</p>
        </div>
      </div>
      <!-- Divider -->
      <hr class="mx-8 border-gray-300" />
    </div>
  </div>
</template>
